<template>
  <WidgetPanel>
    <template #header>
      <div class="flex justify-between items-center">
        <h3 class="widget-headline">
          Feedback geben
        </h3>
        <ActionButton @click="onClick">
          Hier entlang!
        </ActionButton>
      </div>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({experiment: Object});
const target = computed(() => 'https://staudio.tawk.help/');
const onClick = () => window.open(target.value);
</script>
